import React, { Fragment } from "react";
import Layout from "../components/Layout/Layout";

const ErrorPage = (props) => {
  return (
    <Layout>
      <div className="p-2">
        <div className="container">
          <div className="text-center">
            <h1>404</h1>
            <h6>Page not found !</h6>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ErrorPage;
